import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-rpm-gauge',
  templateUrl: './rpm-gauge.component.html',
  styleUrls: ['./rpm-gauge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RpmGaugeComponent implements OnInit {
  @Input() rpm = 0;
  @Input() unit = 'RPM';
  @ViewChild('rpmNeedle') rpmNeedle!: ElementRef<HTMLElement>;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.setRpm(this.rpm);
  }

  setRpm(rpm: number) {
    const minAngle = -71;
    const maxAngle = 171;
    const maxRpm = 8000;

    const angle = minAngle + (rpm / maxRpm) * (maxAngle - minAngle);
    this.rpmNeedle.nativeElement.style.transform = `rotate(${angle}deg)`;
  }
}
